import { shortDateFormat, decimalFormat, percentFormat, onlyAllowNumbers } from './formatters.js';

const CURRENT_YEAR = new Date().getFullYear();

export const MAX_LEADERBOARD_COLUMNS = 3;
export const CLANS_PER_PAGE = 30;
export const PAGES_SHOWN = (width) => width < 600 ? 3 : 5;

export const LEADERBOARD_COLUMNS = {
    'clan_db_id': {field: 'clan_db_id', label: gettext('Regiment Name'), filterable: false},
    'avg_global_rating': {field: 'avg_global_rating', label: gettext('Regiment Rating'), filterable: true,},
    'avg_win_rate': {field: 'avg_win_rate', label: gettext('Avg Win Rate'), filterable: true, formatter: percentFormat},
    'avg_damage': {field: 'avg_damage', label: gettext('Avg Damage'), filterable: true,},
    'clan_kdr': {field: 'clan_kdr', label: gettext('Regiment KDR'), filterable: true, formatter: decimalFormat},
    'avg_battles': {field: 'avg_battles', label: gettext('Avg Battles'), filterable: true, },
    'avg_tank_tier': {field: 'avg_tank_tier', label: gettext('Avg Tank Tier'), filterable: true},
    'avg_survival_rate': {field: 'avg_survival_rate', label: gettext('Avg Survival Rate'), filterable: true, formatter: percentFormat},
    'players_active': {field: 'players_active', label: gettext('Players'), filterable: true},
    'games_played': {field: 'games_played', label: gettext('Games Played'), filterable: true},
};

export const CLAN_COLUMNS = {
    'avg_global_rating': {field: 'avg_global_rating', label: gettext('Regiment Rating'), filterable: true,},
    'avg_win_rate': {field: 'avg_win_rate', label: gettext('Avg Win Rate'), filterable: true, formatter: percentFormat},
    'avg_damage': {field: 'avg_damage', label: gettext('Avg Damage'), filterable: true,},
    'clan_kdr': {field: 'clan_kdr', label: gettext('Regiment KDR'), filterable: true, formatter: decimalFormat},
    'avg_battles': {field: 'avg_battles', label: gettext('Avg Battles'), filterable: true,},
    'avg_tank_tier': {field: 'avg_tank_tier', label: gettext('Avg Tank Tier'), filterable: true},
    'avg_survival_rate': {field: 'avg_survival_rate', label: gettext('Avg Survival Rate'), filterable: true, formatter: percentFormat},
    'players_active': {field: 'players_active', label: gettext('Players'), filterable: true},
    'games_played': {field: 'games_played', label: gettext('Games Played'), filterable: true},
};

export const PLAYER_COLUMNS = {
    'global_rating': {field: 'avg_global_rating', label: gettext('Rating'), filterable: true,},
    'win_rate': {field: 'avg_win_rate', label: gettext('Win Rate'), filterable: true, formatter: percentFormat},
    'avg_damage': {field: 'avg_damage', label: gettext('Avg Damage'), filterable: true,},
    'player_kdr': {field: 'player_kdr', label: gettext('Player KDR'), filterable: true, formatter: decimalFormat},
    'games_played': {field: 'games_played', label: gettext('Games Played'), filterable: true},
    'avg_tank_tier': {field: 'avg_tank_tier', label: gettext('Avg Tank Tier'), filterable: true},
    'survival_rate': {field: 'survival_rate', label: gettext('Survival Rate'), filterable: true, formatter: percentFormat},
    'last_played': {field: 'last_played', label: gettext('Last Played'), filterable: true, formatter: shortDateFormat, sortHelper: (date) => new Date(date)},
};


export const PERIODS = {
    'lt': {label: gettext('All Time')},
    '1y': {label: gettext('Past 365 Days')},
    'ytd': {label: `${CURRENT_YEAR}`}, 
    '30d': {label: gettext('Past 30 Days')},
    '1d': {label: gettext('Past Day')},
}

export const FILTERS = {
    'players_active': {label: gettext("MIN PLAYERS"), formatter: onlyAllowNumbers, validator: (value) => value.substr(0,4)},
}

export const SLOTS= [
    'first',
    'second',
    'third',
]

export const ROLE_ORDER = {
    'commander': 7,
    'executive_officer': 6,
    'recruitment_officer': 5,
    'staff_sergeant': 4,
    'sergeant': 3,
    'corporal': 2,
    'private_first_class': 1,
    'private': 0,
}

export const MEMBER_ROLE = {
    'private': gettext('Private'),
    'recruitment_officer': gettext('Recruitment Officer'),
    'executive_officer': gettext('Executive Officer'),
    'commander': gettext('Commander'),
    'staff_sergeant': gettext('Staff Sergeant'),
    'sergeant': gettext('Sergeant'),
    'corporal': gettext('Corporal'),
    'private_first_class': gettext('Private First Class')
}

export const ROLE_ICONS = {
    'private': `${STATIC_URL}portal/img/svg-icons/clans/rank/private.svg`,
    'recruitment_officer': `${STATIC_URL}portal/img/svg-icons/clans/rank/recruitment_officer.svg`,
    'executive_officer': `${STATIC_URL}portal/img/svg-icons/clans/rank/executive_officer.svg`,
    'commander': `${STATIC_URL}portal/img/svg-icons/clans/rank/commander.svg`,
    'staff_sergeant': `${STATIC_URL}portal/img/svg-icons/clans/rank/staff_sergeant.svg`,
    'sergeant': `${STATIC_URL}portal/img/svg-icons/clans/rank/sergeant.svg`,
    'corporal': `${STATIC_URL}portal/img/svg-icons/clans/rank/corporal.svg`,
    'private_first_class': `${STATIC_URL}portal/img/svg-icons/clans/rank/private_first_class.svg`,
}

export const CLAN_RECRUITING_STATUS = {
   'restricted': gettext("Open For Applications"),
   'closed': gettext("Invitation Only"),
   'open': gettext("Automatically Accept Applications"),
}

export const CLAN_STATUS = {
    'active': gettext("Active"),
    'disbanded': gettext("Disbanded"),
}
